import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "app"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImpersonationBanner = _resolveComponent("ImpersonationBanner")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_BulkUploadStatusBar = _resolveComponent("BulkUploadStatusBar")!

  return (_ctx.shouldShowApp)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ImpersonationBanner),
        _createVNode(_component_router_view),
        _createVNode(_component_BulkUploadStatusBar)
      ]))
    : _createCommentVNode("", true)
}